import * as React from "react";
import { Link, P, Heading4, Stack, TextLink } from "@ovotech/element";
import CheckmarkIcon from "_assets/checkmark.svg";
import { Page } from "_core/components/Page";
import { ProductUrls } from "_core/types/enums";

export const QuoteRequoted = () => {
  return (
    <>
      <Page title="" subtitle="" url={ProductUrls.QuoteRequoted}>
        <Stack spaceBetween={4}>
          <CheckmarkIcon />
          <Heading4>Thanks for your request</Heading4>
          <Heading4>
            Our team will create a new quote and email you with an update soon.
          </Heading4>

          <P>
            Any questions? Give us a call on{" "}
            <TextLink href="tel:03303035059">0330 303 5059</TextLink> (Monday to
            Friday, 9am to 5pm) or email us at{" "}
            <TextLink href="mailto:electricvehicles@ovoenergy.com">
              electricvehicles@ovoenergy.com
            </TextLink>
          </P>

          <Link
            variant="outline"
            data-testid="cableSetup-submit-button"
            href="https://www.ovoenergy.com/"
            target="_self"
          >
            Back to the OVO homepage
          </Link>
        </Stack>
      </Page>
    </>
  );
};
